import api from './api';

/**
 * Service for system maintenance tools
 */
const systemToolsService = {
  /**
   * Progress Data Sync operations
   */
  progressSync: {
    /**
     * Get progress data sync status
     * @returns Promise with the sync status
     */
    getStatus: async () => {
      const response = await api.get('/sync/progress-data');
      return response.data;
    },

    /**
     * Queue sync for all users
     * @returns Promise with the operation result
     */
    syncAll: async () => {
      const response = await api.post('/sync/progress-data', { syncAll: true });
      return response.data;
    }
  },

  /**
   * Janitor service operations
   */
  janitor: {
    /**
     * Run the janitor service
     * @returns Promise with the operation result
     */
    run: async () => {
      const response = await api.post('/janitor/run', {});
      return response.data;
    }
  },

  /**
   * Sync endpoints operations
   */
  syncEndpoints: {
    /**
     * Sync course assignments
     * @returns Promise with the operation result
     */
    syncCourseAssignments: async () => {
      const response = await api.get('/sync/course-assignments');
      return response.data;
    },

    /**
     * Sync users from LMS platform
     * @returns Promise with the operation result
     */
    syncUsers: async () => {
      const response = await api.get('/sync/users');
      return response.data;
    },

    /**
     * Sync courses from LMS platform
     * @returns Promise with the operation result
     */
    syncCourses: async () => {
      const response = await api.get('/sync/courses');
      return response.data;
    }
  }
};

export default systemToolsService;
